module.exports = __webpack_public_path__ + "img/AXIS Logo for Light Backgrounds - Cropped.9ea34c51.png";